import React from 'react'
import bubble from "../Images/bubble.svg"
import { useState } from 'react';
import ScaleH from '../Components/ScaleH';
import ScaleV from '../Components/ScaleV';
import Numbers from '../Components/Numbers';
import axios from 'axios'
import { useEffect } from 'react';
import BarQa from '../Components/BarQa';
import Popup from '../Components/Popup';
import BarQaH from '../Components/BarQaH';
import { format } from "date-fns";
import { utcToZonedTime } from 'date-fns-tz';

const PracticeVideos = ({setDataSummary , step  , setCurrentPage ,levelId , execiserIdBuild }) => {
 
  const [buttondisplay ,Setbuttondisplay] = useState(false) 
  // const [heightscreen ,SetheightScreen] = useState()
  const [col1 ,Setcol1] = useState(-1)
  const [col2 ,Setcol2] = useState(-1)
  const [col3 ,Setcol3] = useState(-1)
  const [col4 ,Setcol4] = useState(-1)
  const [next ,setNext] = useState(false)
  const [message1 ,setMessage1] = useState("")

  const [formattedDate , setFormattedDate] = useState("")

  useEffect(() =>
  {
    const currentDate = new Date();
    const timeZone = 'Asia/Jerusalem';
    const zonedDate = utcToZonedTime(currentDate, timeZone);
    const dateConvert = format(zonedDate, 'yyyy-MM-dd HH:mm:ss');
    setFormattedDate(dateConvert)
  } , [])
   

  // const [typeQ2 , setTypeQ2]  = useState('')  //finish / during

  useEffect ( () => 
  {
      
          console.log(col1,col2,col3,col4)      
  } , [col1,col2,col3])


  const onSubmit = async(typeQ2) =>
  {
    Setbuttondisplay(true)
    // console.log(true)
    if(step === "q1")
    {
      //e.preventDefault()
      await axios.post('function_patient/build_questionnaire_primer' , 
      JSON.stringify({exercise_id: execiserIdBuild , suds: col2 ,
                      vas: col1 ,
                      fatigue: col3 ,
                      well_bing: col4}) , 
      { 
        headers: { 'Content-Type': 'application/json'}
      } ,
      {'Access-Control-Allow-Credentials': true})
        .then((res) => {
        if(res?.status === 200)
         {
            //  if(!res?.data === "Exercise didnt found!")
            //  {
            //   console.log(res?.data)
            //   // onNext()
            //   // setCurrentPage('video')
            //  }
            //  else{
            //    console.log(res?.data)
            //    //navigate back..
            //  } 
            setMessage1(res?.data)
            // setCurrentPage('video')
            setNext(true)
         }
         else{
            if(res.response?.status === 401)
             {
               //logoutFun()
             }
         }
      })
        .catch( (err) => 
            {
              
              // if(err.response?.status === 401)
              // {
              //   logoutFun()
              // }
            })
    }
    else{
      if(step === "q2")
      {
        //e.preventDefault() 
        await axios.post('function_patient/build_questionnaire_last' , 
        JSON.stringify({type:typeQ2 ,  exercise_id: execiserIdBuild ,
                        date_start_quest_second : formattedDate ,  
                        suds: col2 ,
                        vas: col1 ,
                        fatigue: col3 ,
                        well_bing: col4}) , 
        { 
          headers: { 'Content-Type': 'application/json'}
        } ,
        {'Access-Control-Allow-Credentials': true})
          .then((res) => {
          if(res?.status === 200)
           {
            localStorage.removeItem("position")
              if(typeQ2 == 'finish')
              {
                setDataSummary(res?.data)
                setCurrentPage('summary')
              }
              else{
                if(typeQ2 == 'during')
                {
                  setCurrentPage('Finish')
                }
              }

              // console.log(res?.data)

              
                
           }
           else{
              if(res.response?.status === 500)
               {
                // console.log(res?.message)
                 //logoutFun()
               }
           }
        })
          .catch( (err) => 
              {
                
                // if(err.response?.status === 401)
                // {
                //   logoutFun()
                // }
              })
      }
    }
   

  }
//   useEffect(() => {
//     SetheightScreen(window.innerHeight)
//     console.log(heightscreen)
// }, [window.innerHeight])

const arrBgs={
    // 1:"linear-gradient(180deg, #6457A0 38.46%, #A979B0 75.87%, #F5F5F5 97.63%)",
    1:"linear-gradient(rgba(100, 87, 160, 0.34), rgba(169, 121, 176, 0.34), rgba(245, 245, 245, 0.34))",
    // 2:"linear-gradient(180deg, #66539E 38.46%, #4C8ECA 75.87%, #F5F5F5 97.63%)",
    2:"linear-gradient(rgba(102, 83, 158, 0.34), rgba(76, 142, 202, 0.34), rgba(245, 245, 245, 0.34))",
    // 3:"linear-gradient(180deg, #43A1CE 38.42%, #5BBA9F 75.86%, #F5F5F5 97.63%)",
    3:"linear-gradient(rgba(67, 161, 206, 0.34), rgba(91, 186, 159, 0.34), rgba(245, 245, 245, 0.34))",
    // 4:"linear-gradient(180deg, #EA2C69 38.42%, #F07B35 75.86%, #F5F5F5 97.63%)",
    4:"linear-gradient(rgba(234, 44, 105, 0.34), rgba(240, 123, 53, 0.34), rgba(245, 245, 245, 0.34))",
    // 5:"linear-gradient(180deg, #F58A45 38.37%, #FCB73D 75.86%, #F5F5F5 97.63%)"}
    5:"linear-gradient(rgba(245, 138, 69, 0.34), rgba(252, 183, 61, 0.34), rgba(245, 245, 245, 0.34))"}

// console.log(window.innerHeight>670?"42vh":"32vh")
// SetheightScreen(window.innerHeight>670?"42vh":"32vh")
  return (
    // <div className='  h-full flex flex-col  items-center bg-bermuda p-2 '> 
    <div className='   flex flex-col  relative items-center  p-2 ' style={{background:arrBgs[levelId]}}> 
  
    {/* <div className=' w-full h-full ' style={{ backgroundImage: `url(${bubble})` }}> */}
    {/* <div className=' w-full h-full '>
      <img src={bubble} alt="" className='mx-6 pt-5'/>
    <p className=' w-full  flex justify-center'>sda</p></div>
    */}
    {/* <div className='   relative mx-6 pt-5 '> */}
    <div className='w-full  '>
    <svg  className='h-full'   viewBox="0 0 1024 284" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M966.7 0H57.2C25.7 0 0 25.7 0 57.2V159.8C0 191.3 25.7 217 57.2 217H476.9L512.8 283.1L561.4 217H966.7C998.2 217 1023.9 191.3 1023.9 159.8V57.2C1023.9 25.7 998.2 0 966.7 0Z" fill="white"/>
<path d="M91.7216 128.909V128.636C91.7519 125.742 92.0549 123.439 92.6307 121.727C93.2064 120.015 94.0246 118.629 95.0852 117.568C96.1458 116.508 97.4186 115.53 98.9034 114.636C99.7973 114.091 100.6 113.447 101.312 112.705C102.025 111.947 102.585 111.076 102.994 110.091C103.419 109.106 103.631 108.015 103.631 106.818C103.631 105.333 103.282 104.045 102.585 102.955C101.888 101.864 100.956 101.023 99.7898 100.432C98.6231 99.8409 97.3277 99.5455 95.9034 99.5455C94.661 99.5455 93.464 99.803 92.3125 100.318C91.161 100.833 90.1989 101.644 89.4261 102.75C88.6534 103.856 88.2064 105.303 88.0852 107.091H82.358C82.4792 104.515 83.1458 102.311 84.358 100.477C85.5852 98.6439 87.1989 97.2424 89.1989 96.2727C91.214 95.303 93.4489 94.8182 95.9034 94.8182C98.5701 94.8182 100.888 95.3485 102.858 96.4091C104.843 97.4697 106.373 98.9242 107.449 100.773C108.54 102.621 109.085 104.727 109.085 107.091C109.085 108.758 108.828 110.265 108.312 111.614C107.812 112.962 107.085 114.167 106.131 115.227C105.191 116.288 104.055 117.227 102.722 118.045C101.388 118.879 100.32 119.758 99.517 120.682C98.714 121.591 98.1307 122.674 97.767 123.932C97.4034 125.189 97.2064 126.758 97.1761 128.636V128.909H91.7216ZM94.6307 142.364C93.5095 142.364 92.5473 141.962 91.7443 141.159C90.9413 140.356 90.5398 139.394 90.5398 138.273C90.5398 137.152 90.9413 136.189 91.7443 135.386C92.5473 134.583 93.5095 134.182 94.6307 134.182C95.7519 134.182 96.714 134.583 97.517 135.386C98.3201 136.189 98.7216 137.152 98.7216 138.273C98.7216 139.015 98.5322 139.697 98.1534 140.318C97.7898 140.939 97.2973 141.439 96.6761 141.818C96.0701 142.182 95.3883 142.364 94.6307 142.364ZM113.531 136.938C119.302 136.938 123.823 136.406 127.094 135.344L115.5 103.656H121.844L132.094 132.906C134.052 131.51 135.625 129.646 136.812 127.312C138.021 124.958 138.896 121.875 139.438 118.062C140 114.25 140.281 109.448 140.281 103.656H146.312C146.312 113.281 145.292 120.823 143.25 126.281C141.875 129.906 139.948 132.906 137.469 135.281C134.99 137.635 131.792 139.448 127.875 140.719C123.979 141.969 119.198 142.74 113.531 143.031V136.938ZM156.312 103.656C158.125 103.656 159.604 103.802 160.75 104.094C161.917 104.365 162.875 104.885 163.625 105.656C164.375 106.406 165.042 107.51 165.625 108.969C165.938 109.698 166.302 110.833 166.719 112.375C167.135 113.896 167.615 115.833 168.156 118.188L173.594 142H167.906L164.375 126.25C162.625 126.688 161.344 127.219 160.531 127.844C159.74 128.469 159.083 129.396 158.562 130.625C158.292 131.229 158.031 132.021 157.781 133C157.552 133.958 157.323 135.083 157.094 136.375L156.062 142H150.156L151.25 136.312C151.729 133.833 152.208 131.833 152.688 130.312C153.188 128.771 153.812 127.521 154.562 126.562C155.167 125.771 155.906 125.083 156.781 124.5C157.656 123.896 158.917 123.354 160.562 122.875L163.406 122.031C162.885 119.823 162.427 117.979 162.031 116.5C161.635 115 161.302 113.865 161.031 113.094C160.49 111.552 159.896 110.479 159.25 109.875C158.604 109.271 157.688 108.969 156.5 108.969H152.281V103.656H156.312ZM202.438 119.531V142H196.656V119.469C196.656 115.677 195.885 112.979 194.344 111.375C192.823 109.771 190.146 108.969 186.312 108.969H174.594V103.656H186.375C190.208 103.656 193.302 104.198 195.656 105.281C198.01 106.344 199.729 108.042 200.812 110.375C201.896 112.688 202.438 115.74 202.438 119.531ZM240.844 123.375C240.844 135.792 234.969 142 223.219 142H213.25V136.688H223.344C227.323 136.688 230.26 135.583 232.156 133.375C234.052 131.167 235 127.854 235 123.438V122.219C235 117.781 234.042 114.469 232.125 112.281C230.229 110.073 227.302 108.969 223.344 108.969H213.25V103.656H223.219C234.969 103.656 240.844 109.865 240.844 122.281V123.375ZM291.438 119.531V154.031H285.656V119.469C285.656 115.677 284.885 112.979 283.344 111.375C281.823 109.771 279.146 108.969 275.312 108.969H263.594V103.656H275.375C279.208 103.656 282.302 104.198 284.656 105.281C287.01 106.344 288.729 108.042 289.812 110.375C290.896 112.688 291.438 115.74 291.438 119.531ZM301.281 136.938C305.281 135.458 308.698 133.583 311.531 131.312C314.385 129.062 316.552 126.604 318.031 123.938C319.531 121.271 320.281 118.562 320.281 115.812C320.281 111.25 317.844 108.969 312.969 108.969H297.438V89.9688H303.188V103.656H313.562C321.917 103.656 326.094 107.375 326.094 114.812C326.094 118.646 325.177 122.323 323.344 125.844C321.51 129.365 318.927 132.531 315.594 135.344C311.635 138.719 306.865 141.406 301.281 143.406V136.938ZM364.688 138.125C363.25 139.083 361.458 139.865 359.312 140.469C357.188 141.073 354.521 141.521 351.312 141.812C348.104 142.104 344.135 142.271 339.406 142.312L332.094 103.656H338.062L341.906 123.375L344.188 122.938C345.438 122.646 346.469 122.271 347.281 121.812C348.094 121.333 348.74 120.667 349.219 119.812C349.615 119.146 349.917 118.323 350.125 117.344C350.333 116.365 350.49 115.198 350.594 113.844L351.375 103.656H357.312L356.344 113.906C356.198 115.635 356.021 117.135 355.812 118.406C355.604 119.656 355.354 120.667 355.062 121.438C354.542 123 353.76 124.208 352.719 125.062C351.677 125.896 349.948 126.635 347.531 127.281L342.844 128.375L344.375 136.438H345.125C349.312 136.438 352.667 136.198 355.188 135.719C357.708 135.219 359.698 134.448 361.156 133.406C362.135 132.698 362.958 131.823 363.625 130.781C364.292 129.74 364.854 128.365 365.312 126.656C365.771 124.948 366.156 122.75 366.469 120.062L368.438 103.656H374.469L372.469 119.844C372.052 123.469 371.51 126.458 370.844 128.812C370.177 131.146 369.344 133.042 368.344 134.5C367.365 135.938 366.146 137.146 364.688 138.125ZM408.156 136.062C407.448 138.167 406.323 139.688 404.781 140.625C403.24 141.542 400.812 142 397.5 142H397.156V136.688H397.688C399.125 136.688 400.271 136.417 401.125 135.875C401.958 135.333 402.552 134.51 402.906 133.406C403.26 132.281 403.438 130.583 403.438 128.312V108.969H397.5V103.656H418.219C423.969 103.656 428.094 104.885 430.594 107.344C433.094 109.781 434.344 113.844 434.344 119.531V142H428.594V119.469C428.594 115.635 427.812 112.927 426.25 111.344C424.708 109.76 422.01 108.969 418.156 108.969H409.188V127.156C409.188 130.99 408.844 133.958 408.156 136.062ZM450.688 103.656V142H444.938V103.656H450.688ZM490.312 138.125C488.875 139.083 487.083 139.865 484.938 140.469C482.812 141.073 480.146 141.521 476.938 141.812C473.729 142.104 469.76 142.271 465.031 142.312L457.719 103.656H463.688L467.531 123.375L469.812 122.938C471.062 122.646 472.094 122.271 472.906 121.812C473.719 121.333 474.365 120.667 474.844 119.812C475.24 119.146 475.542 118.323 475.75 117.344C475.958 116.365 476.115 115.198 476.219 113.844L477 103.656H482.938L481.969 113.906C481.823 115.635 481.646 117.135 481.438 118.406C481.229 119.656 480.979 120.667 480.688 121.438C480.167 123 479.385 124.208 478.344 125.062C477.302 125.896 475.573 126.635 473.156 127.281L468.469 128.375L470 136.438H470.75C474.938 136.438 478.292 136.198 480.812 135.719C483.333 135.219 485.323 134.448 486.781 133.406C487.76 132.698 488.583 131.823 489.25 130.781C489.917 129.74 490.479 128.365 490.938 126.656C491.396 124.948 491.781 122.75 492.094 120.062L494.062 103.656H500.094L498.094 119.844C497.677 123.469 497.135 126.458 496.469 128.812C495.802 131.146 494.969 133.042 493.969 134.5C492.99 135.938 491.771 137.146 490.312 138.125ZM514.062 103.656V142H508.312V103.656H514.062ZM550.719 119.469C550.719 115.677 549.948 112.979 548.406 111.375C546.885 109.771 544.208 108.969 540.375 108.969H530.688V142H524.938V103.656H540.438C546.188 103.656 550.302 104.885 552.781 107.344C555.26 109.802 556.5 113.865 556.5 119.531V142H550.719V119.469ZM574.531 136.062C573.823 138.167 572.698 139.688 571.156 140.625C569.615 141.542 567.188 142 563.875 142H563.531V136.688H564.062C565.5 136.688 566.646 136.417 567.5 135.875C568.333 135.333 568.927 134.51 569.281 133.406C569.635 132.281 569.812 130.583 569.812 128.312V108.969H563.875V103.656H584.594C590.344 103.656 594.469 104.885 596.969 107.344C599.469 109.781 600.719 113.844 600.719 119.531V142H594.969V119.469C594.969 115.635 594.188 112.927 592.625 111.344C591.083 109.76 588.385 108.969 584.531 108.969H575.562V127.156C575.562 130.99 575.219 133.958 574.531 136.062ZM641.344 119.531V142H635.562V119.469C635.562 115.635 634.781 112.927 633.219 111.344C631.677 109.76 629 108.969 625.188 108.969H610.625V103.656H625.281C629.115 103.656 632.208 104.198 634.562 105.281C636.917 106.344 638.635 108.042 639.719 110.375C640.802 112.688 641.344 115.74 641.344 119.531ZM617 117.094V142H611.25V117.094H617ZM677.344 136.062C676.635 138.167 675.51 139.688 673.969 140.625C672.427 141.542 670 142 666.688 142H666.344V136.688H666.875C668.312 136.688 669.458 136.417 670.312 135.875C671.146 135.333 671.74 134.51 672.094 133.406C672.448 132.281 672.625 130.583 672.625 128.312V108.969H666.688V103.656H687.406C693.156 103.656 697.281 104.885 699.781 107.344C702.281 109.781 703.531 113.844 703.531 119.531V142H697.781V119.469C697.781 115.635 697 112.927 695.438 111.344C693.896 109.76 691.198 108.969 687.344 108.969H678.375V127.156C678.375 130.99 678.031 133.958 677.344 136.062ZM733 103.031C738.042 103.031 741.719 104.573 744.031 107.656C746.365 110.719 747.531 115.594 747.531 122.281V142H728.719V136.688H741.719V123C741.719 117.896 741.062 114.188 739.75 111.875C738.438 109.562 736.208 108.406 733.062 108.406C730.25 108.406 727.938 109.677 726.125 112.219C724.292 114.802 722.615 119.292 721.094 125.688L717.188 142H711L715.281 125.219C715.76 123.26 716.25 121.49 716.75 119.906C717.25 118.323 717.74 116.917 718.219 115.688L710.406 103.656H717.188L721.094 110C722.719 107.542 724.458 105.771 726.312 104.688C728.167 103.583 730.396 103.031 733 103.031ZM784.812 137.062V142H755.312V136.688H777.656L753 103.656H760.188L772.094 119.844C773.698 119.156 774.865 118.146 775.594 116.812C776.323 115.458 776.812 113.396 777.062 110.625L777.781 103.656H783.719L783.094 110.5C782.823 113.375 782.396 115.583 781.812 117.125C781.229 118.646 780.406 119.906 779.344 120.906C778.281 121.906 776.781 122.792 774.844 123.562L784.812 137.062ZM798.75 103.656V142H793V103.656H798.75ZM805.469 136.938C811.24 136.938 815.76 136.406 819.031 135.344L807.438 103.656H813.781L824.031 132.906C825.99 131.51 827.562 129.646 828.75 127.312C829.958 124.958 830.833 121.875 831.375 118.062C831.938 114.25 832.219 109.448 832.219 103.656H838.25C838.25 113.281 837.229 120.823 835.188 126.281C833.812 129.906 831.885 132.906 829.406 135.281C826.927 137.635 823.729 139.448 819.812 140.719C815.917 141.969 811.135 142.74 805.469 143.031V136.938ZM894.906 119.531V142H889.125V119.469C889.125 115.635 888.344 112.927 886.781 111.344C885.24 109.76 882.562 108.969 878.75 108.969H864.188V103.656H878.844C882.677 103.656 885.771 104.198 888.125 105.281C890.479 106.344 892.198 108.042 893.281 110.375C894.365 112.688 894.906 115.74 894.906 119.531ZM870.562 117.094V142H864.812V117.094H870.562ZM924.312 103.031C929.354 103.031 933.031 104.573 935.344 107.656C937.677 110.719 938.844 115.594 938.844 122.281V142H920.031V136.688H933.031V123C933.031 117.896 932.375 114.188 931.062 111.875C929.75 109.562 927.521 108.406 924.375 108.406C921.562 108.406 919.25 109.677 917.438 112.219C915.604 114.802 913.927 119.292 912.406 125.688L908.5 142H902.312L906.594 125.219C907.073 123.26 907.562 121.49 908.062 119.906C908.562 118.323 909.052 116.917 909.531 115.688L901.719 103.656H908.5L912.406 110C914.031 107.542 915.771 105.771 917.625 104.688C919.479 103.583 921.708 103.031 924.312 103.031Z" fill="black"/>
</svg>

    {/* <p className=' absolute  flex justify-center items-center pb-10 '>sda</p>
      <img src={bubble} alt="" className=''/> */}
    {/* <p className=' absolute w-full  flex justify-center '>sda</p> */}
     </div>


     {/* <div className={`min-h-[650px]:h-[0vh] h-[45vh] max-[380px]:h-[32vh] max-[320px]:h-[35vh] rounded-3xl bg-white m-4 flex flex-row  `}  > */}
     <div className=" w-full h-[50vh] rounded-3xl  bg-white m-2 justify-between flex flex-row  "  >
    
    
    <div className=' h-full flex justify-center items-center w-[33vw] flex-col  '>
    <text className='font-Hebbo font-bold text-center pr-8 'style={{fontSize:"3vh"}}>כאב</text>
    
    <div className='flex flex-row  h-full w-full  justify-center'>
    <BarQa setcol={Setcol1} title={"כאב"}col={col1}/>
    {/* <Numbers/> */}
    </div>
    </div>
    
    
    
    <div className='h-full flex justify-center items-center w-[33vw] flex-col  '>
    <text className='font-Hebbo font-bold text-center pr-8'style={{fontSize:"3vh"}}>דחק</text>
    <div className='flex flex-row  h-full w-full justify-center'>
    <BarQa setcol={Setcol2} title={"מתח"} col={col2}/>
    {/* <Numbers/> */}
    </div>
    </div>


    {/* <div className='h-full flex justify-center items-center w-[33vw] flex-col p-4'>
    <text className='font-Hebbo font-bold text-center pr-8'style={{fontSize:"3vh"}}>עייפות</text>
   <div className='flex flex-row  h-full w-full justify-center '>
    <ScaleV setcol={Setcol3} col={col3} className=""/>
    <Numbers />
    </div>
    </div> */}
    
    <div className='h-full flex justify-center items-center w-[33vw] flex-col  '>
    <text className='font-Hebbo font-bold text-center pr-8'style={{fontSize:"3vh"}}>תשישות</text>
    <div className='flex flex-row  h-full w-full justify-center'>
    <BarQa setcol={Setcol3} title={"מתח"} col={col3}/>
    {/* <Numbers/> */}
    </div>
    </div>
    
    </div>

    
    <div className=' rounded-2xl bg-white  w-full mx-2 flex justify-center flex-col items-center  ' >
    <text className='font-Hebbo font-bold 'style={{fontSize:"3vh"}}>רווחה נפשית</text>
    {/* <ScaleH setcol={Setcol4} col={col4}/>  */}
    <BarQaH setcol={Setcol4} col={col4}></BarQaH>
    </div>
    <div className={step=="q2"?'w-[85%] sm:w-[400px]    py-2 flex justify-end':'w-[80%] sm:w-[400px]  px-4  py-2 flex justify-start'}>
            {step=="q2"?
                
            (col1>-1&&col2>-1&&col3>-1&&col4>-1)?
            <div className='w-[80vw] flex justify-between'>
            <button className='rounded-2xl  p-4  font-Hebbo font-normal text-white flex justify-end' 
            disabled={buttondisplay} style={{background:"#394351"}} 
              onClick = {
                ()=>{
                  onSubmit('during') 
                } 
              }
              
              >להמשיך לתרגל</button>
            <button className=' rounded-2xl  p-4 px-8 prfont-Hebbo font-normal   text-white'
             disabled={buttondisplay}
            style={{background:"linear-gradient(90deg, #E72144 0%, #76549E 99.94%)"}}
            onClick = {
              ()=>{
                onSubmit('finish') 
              } 
            }>סיימתי</button>
            </div>
            :
            <div className='w-[80vw] flex justify-between'>
            <button className=' rounded-lg  p-4 text-white bg-gray-300  focus:outline-none' disabled>להמשיך לתרגל</button>
            <button className=' rounded-lg  p-4 px-8 text-white bg-gray-300  focus:outline-none' disabled>סיימתי</button>
            </div>   
            
            
            
            :
            (col1>-1&&col2>-1&&col3>-1&&col4>-1)?<button className=' rounded-2xl  p-4  font-Hebbo font-normal text-white flex justify-end 'style={{background:"#394351"}}  disabled={buttondisplay} onClick={onSubmit}>המשך</button>:<button className='rounded-lg  p-4 text-white bg-gray-300  focus:outline-none' disabled>המשך</button>}


            
        </div>
        {next&&<Popup setCurrentPage={setCurrentPage} message={message1}></Popup>}
  
  </div>
  )
}

export default PracticeVideos